import React from 'react';
import PropTypes from 'prop-types';
import Box from '4all-ui/components/Box';
import * as styled from './style';

const BoxComponent = ({
  title,
  content,
  headerContent,
  size,
  customStyles,
  contentStyles,
  headerStyles,
}) => (
  <Box colSize={size} customStyles={customStyles}>
    <styled.Header headerStyles={headerStyles}>
      <styled.Title>{title}</styled.Title>

      {headerContent}
    </styled.Header>

    <styled.Content contentStyles={contentStyles}>{content}</styled.Content>
  </Box>
);

BoxComponent.propTypes = {
  title: PropTypes.string.isRequired,
  contentStyles: PropTypes.object,
  customStyles: PropTypes.object,
  headerStyles: PropTypes.object,
  headerContent: PropTypes.any,
  content: PropTypes.any,
  size: PropTypes.number,
};

BoxComponent.defaultProps = {
  headerContent: null,
  contentStyles: {},
  customStyles: {},
  headerStyles: {},
  content: null,
  size: 4,
};

export default BoxComponent;



// WEBPACK FOOTER //
// ./src/screens/Home/Components/OrderDetails/Components/Box/index.js